import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import React, { useCallback, useEffect, useState } from "react";
import { getLateOrderStats } from "../../../../api/DeliveryAnalyticsService";

export const LateOrdersStats = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, [loadData, startDate, endDate]);

  const loadData = useCallback(async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError(null);

    try {
      // Create params object for API calls
      const params = {
        start_date: startDate,
        end_date: endDate,
      };

      // Call the stats API
      const response = await getLateOrderStats(params);

      // Set stats data directly from API response
      setData(response.data);
    } catch (err) {
      console.error("Error loading order stats data:", err);
      setError("Não foi possível carregar os dados de pedidos");
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <AccessTimeFilledIcon sx={{ mr: 1, color: "error.main" }} />
        <Typography variant="h6">Entregas Atrasadas</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Total de Atrasos
          </Typography>
          <Typography variant="h5">
            {data.totalLateOrders.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            % de Todos Pedidos
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color:
                data.latePercentage > 5
                  ? "error.main"
                  : data.latePercentage > 2
                  ? "warning.main"
                  : "success.main",
            }}
          >
            {data.latePercentage.toFixed(1)}%
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Tempo Médio de Atraso
          </Typography>
          <Typography variant="h5">{data.avgLateTime} min</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            vs. Período Anterior
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              sx={{
                color: data.percentChange <= 0 ? "success.main" : "error.main",
              }}
            >
              {data.percentChange.toFixed(1)}%
            </Typography>
            {data.percentChange <= 0 ? (
              <TrendingDownIcon sx={{ ml: 0.5, color: "success.main" }} />
            ) : (
              <TrendingUpIcon sx={{ ml: 0.5, color: "error.main" }} />
            )}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
